import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/WPS_WLAN_Schnellverbindung_bei_einem_Linksys_Router.mp4" />
        </Player>
        <EuiText>
            <p>WPS / WLAN Schnellverbindung mit einem Linksys Router. Auf <OutboundLink href="https://www.youtube.com/watch?v=EY7QT4rPfWk" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard